const STAR =
  "M0,-5 L1.47,-2.02 L4.76,-1.55 L2.38,0.77 L2.94,4.05 L0,2.0 L-2.94,4.05 L-2.38,0.77 L-4.76,-1.55 L-1.47,-2.02 Z";

export default function KushFlag({ className = "w-16 h-11" }) {
  return (
    <svg viewBox="0 0 90 60" className={className} role="img" aria-label="Flag of the Kingdom of Kush" data-testid="kush-flag">
      <rect width="90" height="60" fill="#CE1126" />
      {[22.5, 45, 67.5].map((cx) => (
        <g key={cx}>
          <path d={STAR} transform={`translate(${cx} 12)`} fill="#FFD700" />
          <polygon points={`${cx - 13},52 ${cx},25 ${cx + 13},52`} fill="#FFD700" />
          <polygon points={`${cx},25 ${cx + 13},52 ${cx},52`} fill="#DAA520" />
        </g>
      ))}
    </svg>
  );
}
